function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { toGetWeek } from '@/utils/format';
import { attendanceShiftListApi, rosterCycleListApi, getAttendanceArrangeApi, saveAttendanceArrangeApi } from '@/api/config';
export default {
  name: 'CrmebOaEntAddSchedul',
  components: {
    addCycle: function addCycle() {
      return import('./components/addCycle');
    }
  },
  props: {
    id: {
      type: Number,
      default: 0 //考勤组id
    },
    newData: {
      type: Object,
      default: {} //考勤组数据
    }
  },
  data: function data() {
    return {
      where: {
        name: '',
        date: ''
      },
      sameDay: 0,
      // 当天
      activeName: '1',
      activeName1: '1',
      activeName2: '1',
      loading: false,
      cycleList: [],
      shiftsList: [{
        name: '清空',
        color: 'rgba(229, 241, 255, 1)',
        id: 0
      }],
      tableData: [],
      colData: [],
      // 这是shiftsList 和 cycleList 的数据
      shiftsMappingList: [],
      rowIndex: null,
      columnIndex: -2,
      cellRow: null,
      cellIndex: null,
      activeRow: false,
      activeColumn: false,
      activeCell: false,
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now();
        }
      }
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.where.date = this.$moment(this.newData.date).format('yyyy-MM');
    this.getday();
    this.getDataOptionalList().then(function () {
      _this.getList();
    });
  },
  methods: {
    getday: function getday() {
      var date = new Date();
      if (this.$moment(this.where.date).format('YYYY-MM') == this.$moment().format('YYYY-MM')) {
        this.sameDay = date.getDate();
      } else {
        this.sameDay = 0;
      }
    },
    submit: function submit() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var object;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              object = {
                date: _this2.where.date,
                data: _this2.tableData.map(function (item) {
                  return {
                    uid: item.id,
                    shifts: item.counts.map(function (v) {
                      // 1. v 是0
                      // 2. v 是一个渲染对象
                      // 如果v是一个渲染对象, 则取v.id
                      if (_typeof(v) === 'object') {
                        return v.id;
                      }
                      if (!v) {
                        return 0;
                      }
                      // 如果v是0, 则取v
                      return v;
                    })
                  };
                })
              };
              _context.next = 3;
              return saveAttendanceArrangeApi(_this2.id, object);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 点击选中单元格
    clickFn: function clickFn(row, index, data) {
      this.$set(this.tableData[row.$index].counts, [index], data.id == 0 ? 0 : data);
      // 手动关闭
      var ref = 'pop' + index;
      this.$refs[ref][row.$index].doClose();
      this.activeCell = false;
    },
    // 点击选中整行
    clickName: function clickName(row, data) {
      var _this3 = this;
      this.colData.map(function (item, index) {
        if (data.id == 0) {
          _this3.$set(_this3.tableData[row.$index].counts, index, 0);
        } else {
          if (index >= _this3.sameDay) {
            _this3.$set(_this3.tableData[row.$index].counts, index, data);
          }
        }
      });
      var ref = 'row' + row.$index;
      this.$refs[ref].doClose();
      this.rowIndex = null;
      this.activeRow = false;
    },
    // 点击选中整列
    headerClick: function headerClick(val, data) {
      var _this4 = this;
      this.columnIndex = val;
      this.tableData.forEach(function (item, index) {
        _this4.$set(item.counts, val, data.id === 0 ? 0 : data);
      });
      this.columnIndex = -2;
      var ref = 'column' + val;
      this.$refs[ref][0].doClose();
      this.activeColumn = false;
    },
    // 选中行渲染周期
    clickCycle: function clickCycle(type, row, data, index) {
      var _this5 = this;
      // 选中整行
      if (type == 1) {
        if (data.id == 0) {
          this.tableData[row.$index].counts = [];
        } else {
          var n = this.colData.length;
          var mul = n / data.shifts.length;
          var rem = n % data.shifts.length;
          mul = parseInt(mul);
          this.tableData[row.$index].counts = [];
          for (var i = 0, len = mul; i < len; i++) {
            var _this$tableData$row$$;
            (_this$tableData$row$$ = this.tableData[row.$index].counts).push.apply(_this$tableData$row$$, _toConsumableArray(data.shifts));
          }
          var newData = data.shifts.slice(0, rem);
          newData.map(function (item) {
            _this5.tableData[row.$index].counts.push(item);
          });
          if (this.sameDay !== 0) {
            this.tableData[row.$index].counts.forEach(function (item, i) {
              if (i < _this5.sameDay) {
                _this5.tableData[row.$index].counts[i] = 0;
              }
            });
          }
          this.rowIndex = null;
          var ref = 'row' + row.$index;
          this.$refs[ref].doClose();
        }
      }
      // 选中整列
      if (type == 2) {
        this.tableData.forEach(function (item, index) {
          if (data.id == 0) {
            _this5.$set(item.counts, row, 0);
          } else {
            _this5.$set(item.counts, row, data.shifts[0]);
          }
        });
        this.columnIndex = -2;
        var _ref = 'column' + row;
        this.$refs[_ref][0].doClose();
      }
      if (type == 3) {
        if (data.id == 0) {
          this.$set(this.tableData[row.$index].counts, index, {});
        } else {
          this.$set(this.tableData[row.$index].counts, index, data.shifts[0]);
        }
        var _ref2 = 'pop' + index;
        this.$refs[_ref2][row.$index].doClose();
      }
    },
    clickRowIndex: function clickRowIndex(name) {
      this.activeRow = true;
      this.rowIndex = name;
      this.columnIndex = -2;
      this.cellRow = null;
      this.cellIndex = null;
    },
    clickColumnIndex: function clickColumnIndex(index) {
      this.activeColumn = true;
      this.columnIndex = index;
      this.rowIndex = null;
      this.cellRow = null;
      this.cellIndex = null;
    },
    cellFn: function cellFn(row, index) {
      this.activeCell = true;
      this.cellRow = row.$index;
      this.cellIndex = index;
      this.columnIndex = -2;
      this.rowIndex = null;
    },
    // 单元格样式
    cellStyle: function cellStyle(_ref3) {
      var row = _ref3.row,
        rowIndex = _ref3.rowIndex,
        columnIndex = _ref3.columnIndex;
      if (this.activeColumn) {
        if (this.columnIndex + 1 == columnIndex) {
          return {
            background: 'rgba(24, 144, 255, 0.2)'
          };
        }
      }
      if (this.activeRow) {
        if (row.name == this.rowIndex) {
          return {
            background: 'rgba(24, 144, 255, 0.2)'
          };
        }
      }
      if (this.activeCell) {
        if (this.cellIndex + 1 == columnIndex && this.cellRow == rowIndex) {
          return {
            background: 'rgba(24, 144, 255, 0.2)'
          };
        }
      }
    },
    // 获取班次 / 周期列表
    getDataOptionalList: function getDataOptionalList() {
      var _this6 = this;
      this.loading = true;
      return new Promise(function (resolve, reject) {
        var data = {
          page: 1,
          group_id: _this6.id
        };
        var p1 = attendanceShiftListApi(data);
        var p2 = rosterCycleListApi(_this6.id);
        Promise.all([p1, p2]).then(function (res) {
          _this6.shiftsList = res[0].data.list;
          _this6.shiftsList.unshift({
            name: '清空',
            color: 'rgba(229, 241, 255, 1)',
            id: 0
          });
          _this6.cycleList = res[1].data;
          _this6.cycleList.unshift({
            name: '清空',
            id: 0
          });
          // 集合映射列表
          _this6.shiftsMappingList = _toConsumableArray(_this6.shiftsList);
          _this6.cycleList.forEach(function (item) {
            if (item.shifts) {
              item.shifts.forEach(function (data) {
                if (_this6.shiftsMappingList.findIndex(function (i) {
                  return i.id === data.id;
                }) === -1) {
                  _this6.shiftsMappingList.push(data);
                }
              });
            }
          });
          // 后续的方法可以then了
          resolve();
        });
      });
    },
    // 周期列表
    getCycleList: function getCycleList() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return rosterCycleListApi(_this7.id);
            case 2:
              result = _context2.sent;
              _this7.cycleList = [{
                name: '清空',
                id: 0
              }];
              result.data.map(function (item) {
                _this7.cycleList.push(item);
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 打开排班周期
    addCycleFn: function addCycleFn() {
      this.$refs.addCycle.openBox(this.id, 'add');
    },
    getList: function getList() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this8.getday();
              _this8.tableData = [];
              _this8.colData = [];
              _this8.where.date = _this8.$moment(_this8.where.date).format('yyyy-MM');
              _context3.next = 6;
              return getAttendanceArrangeApi(_this8.id, _this8.where);
            case 6:
              result = _context3.sent;
              _this8.tableData = result.data.members.map(function (per) {
                return {
                  id: per.id,
                  name: per.name,
                  counts: _this8.generateSchedulingCycleData(per.id, result.data.arrange, result.data.calendar.length)
                };
              });

              // 生成表格头信息
              _this8.colData = result.data.calendar.map(function (item, index) {
                return {
                  date: item.date,
                  is_rest: item.is_rest
                };
              });
              _this8.loading = false;
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    /**
     *
     * 生成排版数据映射数据
     * @param {} id 排版人员id
     * @param {*} arr 排版数据
     * @param {*} length 排版天数
     */
    generateSchedulingCycleData: function generateSchedulingCycleData(id, arr, length) {
      var _this9 = this;
      // 如果接口返回的排班数据为空, 则返回一个对应排版天数的空数组
      if (!arr || arr.length === 0 || !arr.find(function (item) {
        return item.uid === id;
      })) return new Array(length).fill(0);
      // 如果接口返回的排班数据不为空, 判断接口返回的这个人的数据是否齐全
      var findResObj = arr.find(function (item) {
        return item.uid === id;
      });
      if (findResObj && findResObj.shifts) {
        if (findResObj.shifts.length === length) {
          // 如果接口返回的这个人的数据齐全, 则返回对应映射数据返回页面的渲染元素
          return findResObj.shifts.map(function (id) {
            return _this9.shiftsMappingList.find(function (per) {
              if (id === 0) return 0;
              return per.id === id;
            });
          });
        }

        // 如果接口返回的这个人的数据不齐全, 则返回对应的渲染对象, 剩下数据补齐
        var tempArr = [];
        var _loop = function _loop(i) {
          if (findResObj.shifts[i]) {
            tempArr.push(_this9.shiftsMappingList.find(function (per) {
              if (findResObj.shifts[i] === 0) return 0;
              return per.id === findResObj.shifts[i];
            }));
          } else {
            tempArr.push(0);
          }
        };
        for (var i = 0; i < length; i++) {
          _loop(i);
        }
        return tempArr;
      }
    },
    backFn: function backFn() {
      this.$emit('backFn');
    },
    restFn: function restFn() {
      this.where.name = '';
      this.where.date = this.$moment(this.newData.date).format('yyyy-MM');
    },
    getWeek: function getWeek(date) {
      // 参数时间戳
      return toGetWeek(date);
    }
  }
};